/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import HelpButton from 'app/components/common/HelpButton.jsx';
import ToggleControl from 'app/components/common/ToggleControl.jsx';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import Loading from 'app/components/common/Loading.jsx';
import * as _ from 'underscore';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

const STYLE_AUTO_DETECT = 'STYLE_AUTO_DETECT';
const STYLE_FIXED_DYNAMIC = 'STYLE_FIXED_DYNAMIC';
const STYLE_AI_GENERATED = 'STYLE_AI_GENERATED';

class InputHashtagPanel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            inputs: {
                poolField: ''
            },
            relatedTags: [],
            searchingRelated: false,
            localErrors: {
                modal: '',
                hashStatic: '',
                hashPool: '',
                search: '',
                smartHashtags: ''
            },
            warning: '',
            hashtagStyle: 0,
            debounceId: 0
        };

        this.updateField = this.updateField.bind(this);
        this.updateHashtags = this.updateHashtags.bind(this);
        this.addTextTagsToPool = this.addTextTagsToPool.bind(this);
        this.addRelatedTag = this.addRelatedTag.bind(this);
        this.updateTags = this.updateTags.bind(this);
        this.findTags = this.findTags.bind(this);
        this.removeTag = this.removeTag.bind(this);
        this.dupeCheck = this.dupeCheck.bind(this);
        this.closeTagModal = this.closeTagModal.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.changeStyle = this.changeStyle.bind(this);
        this.setHashtagStyle = this.setHashtagStyle.bind(this);
        this.onStaticBlur = this.onStaticBlur.bind(this);

    }

    componentDidMount() {
        document.addEventListener('keyup', this.onKeyUp);

        if (this.props.input) {
            this.setHashtagStyle();
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.onKeyUp);
    }

    componentDidUpdate(prevProps, prevState) {
        let localErrors = _.clone(this.state.localErrors),
            errors = [];

        if (prevProps.app.loading.UTILITIES_FETCH_RELATED_HASHTAGS === true && this.props.app.loading.UTILITIES_FETCH_RELATED_HASHTAGS === false) {
            if (this.props.utilities.relatedTags.length === 0) {
                localErrors.search = "There were no results for '" + this.state.inputs.poolField + "'.";
            }
        }

        errors = this.props.getApiErrors(['UTILITIES_FETCH_RELATED_HASHTAGS']);
        if (errors.length) {
            if (errors[0].errors !== undefined && errors[0].errors.msg) {
                localErrors.search = errors[0].errors.msg;
            } else if (errors[0].errors !== undefined && errors[0].errors.validation && errors.errors.validation.tag) {
                localErrors.search = "A search term is required";
            }
        }

        if (!_.isEqual(localErrors, this.state.localErrors)) {
            this.setState({
                localErrors
            });
        }

        if (prevState.searchingRelated === true && this.state.searchingRelated === true) {
            this.setState({
                searchingRelated: false
            });
        }

        if (prevProps.app.loading.INPUT_SHOW === true && this.props.app.loading.INPUT_SHOW === false) {
            this.setHashtagStyle();
        }

    }

    changeStyle(e) {
        let updateEvent = {
                currentTarget: {
                    dataset: {
                        field: this.props.statePath + ".attrs"
                    }
                },
                target: {
                    value: 0
                }
            },
            inputAttrs = _.clone(this.props.input.attrs),
            hashtagStyle = e.target.value,
            constants = this.props.app.config.constants;


        switch (hashtagStyle) {
            case STYLE_AUTO_DETECT:
                if (!this.props.user.perms.resources.autoHash) {
                    this.props.showUpgradeModal(this.props.closeAllModals, 'autoHashtags', null, 'input_edit');
                }
                inputAttrs.hashTags.staticActive = 0;
                inputAttrs.hashTags.poolNum = 0;
                inputAttrs.hashTags.poolActive = 0;
                inputAttrs.autoHash = 1;
                break;

            case STYLE_FIXED_DYNAMIC:
                if (!this.props.user.perms.resources.hashStatic && !this.props.user.perms.resources.hashPool) {
                    this.props.showUpgradeModal(this.props.closeAllModals, 'staticHashtags', null, 'input_edit');
                }
                inputAttrs.autoHash = 0;
                inputAttrs.autoHashNum = 0;
                inputAttrs.autoHashSpaces = 0;
                inputAttrs.hashTags.poolActive = 1;
                inputAttrs.hashTags.smartHashtags = 0;
                inputAttrs.hashTags.smartHashtagQty = 0;
                inputAttrs.autoHashSource = constants.HASH_SRC_PAGE;
                if (inputAttrs.hashTags.hashPool === undefined) {
                    inputAttrs.hashTags.hashPool = [];
                }
                if (inputAttrs.hashTags.hashStatic === undefined) {
                    inputAttrs.hashTags.hashStatic = [];
                }
                break;

            case STYLE_AI_GENERATED:
                if (!this.props.user.perms.resources.smartHashtags) {
                    this.props.showUpgradeModal(this.props.closeAllModals, 'smartHashtags', null, 'input_edit');
                } else {
                    inputAttrs.hashTags.smartHashtags = 1;
                    inputAttrs.hashTags.smartHashtagQty = 5;
                    inputAttrs.autoHash = 0;
                    inputAttrs.autoHashNum = 0;
                    inputAttrs.autoHashSpaces = 0;
                    inputAttrs.hashTags.poolActive = 0;
                    inputAttrs.hashTags.staticActive = 0;
                    inputAttrs.autoHashSource = constants.HASH_SRC_PAGE;
                    if (inputAttrs.hashTags.hashPool === undefined) {
                        inputAttrs.hashTags.hashPool = [];
                    }
                    if (inputAttrs.hashTags.hashStatic === undefined) {
                        inputAttrs.hashTags.hashStatic = [];
                    }
                }
                break;

            default:
                inputAttrs.autoHash = 0;
                inputAttrs.autoHashNum = 0;
                inputAttrs.autoHashSpaces = 0;
                inputAttrs.autoHashSource = constants.HASH_SRC_PAGE;
                inputAttrs.hashTags.staticActive = 0;
                inputAttrs.hashTags.poolNum = 0;
                inputAttrs.hashTags.poolActive = 0;
                inputAttrs.hashTags.smartHashtags = 0;
                inputAttrs.hashTags.smartHashtagQty = 0;
                break;
        }

        updateEvent.target.value = inputAttrs;

        this.props.changeHandler(updateEvent);

        this.setState({
            hashtagStyle
        });

    }

    setHashtagStyle() {
        let autoHash = (this.props.input.attrs) ? parseInt(this.props.input.attrs.autoHash, 10) : 0,
            smartHashtags = (this.props.input.attrs) ? parseInt(this.props.input.attrs.hashTags.smartHashtags, 10) : 0,
            // default static active to true for migration -- it won't be set for prior users, but as soon as they touch it (and for new setups) it'll be set
            staticActive = (this.props.input.attrs && this.props.input.attrs.hashTags.staticActive !== undefined) ? parseInt(this.props.input.attrs.hashTags.staticActive, 10) : 1,
            staticTags = (this.props.input.attrs && this.props.input.attrs.hashTags.hashStatic !== undefined) ? this.props.input.attrs.hashTags.hashStatic : [],
            poolActive = (this.props.input.attrs && this.props.input.attrs.hashTags.poolActive !== undefined) ? parseInt(this.props.input.attrs.hashTags.poolActive, 10) : 0,
            hashtagStyle = 0;

        if (autoHash) {
            hashtagStyle = STYLE_AUTO_DETECT;
        } else if (smartHashtags) {
            hashtagStyle = STYLE_AI_GENERATED;
        } else if ((staticActive && staticTags.length) || poolActive) {
            hashtagStyle = STYLE_FIXED_DYNAMIC;
        }

        this.setState({
            hashtagStyle
        });
    }

    onKeyUp(e) {

        if (e.key === 'Enter' && this.state.inputs.poolField !== '') {
            this.addTextTagsToPool();
        }

    }

    updateField(e) {

        FormUtilityMixin.requestChange.apply(this, [e]);

    }

    updateHashtags(e, dupeCheck) {
        let dataEvent = {
                target: {
                    value: []
                },
                currentTarget: {
                    dataset: e.currentTarget.dataset,
                }
            },
            newValues = e.currentTarget.value.split(" "),
            fieldUpdate = [],
            localErrors = this.state.localErrors,
            constants = this.props.app.config.constants,
            dupeTags = [];

        localErrors.hashStatic = '';

        if (newValues.length > constants.HASH_STATIC_MAX) {
            localErrors.hashStatic = "The maximum number of fixed tags allowed is: " + constants.HASH_STATIC_MAX;
        } else {
            for (let i = 0; i < newValues.length; ++i) {
                if (!newValues[i].match(/^\#/) && newValues[i].match(/\w+/)) {
                    newValues[i] = "#" + newValues[i];
                }
                if (dupeCheck !== undefined && dupeCheck) {
                    if (this.dupeCheck(this.props.input.attrs.hashTags.hashStatic[i], 'static')) {
                        if (dupeTags.indexOf(this.props.input.attrs.hashTags.hashStatic[i]) === -1) {
                            dupeTags.push(this.props.input.attrs.hashTags.hashStatic[i]);
                            continue;
                        }
                    }
                }
                fieldUpdate.push(newValues[i]);
            }

            if (dupeTags.length) {
                if (dupeTags.length === 1) {
                    localErrors.hashStatic = dupeTags.join("") + " is a duplicate tag";
                } else {
                    localErrors.hashStatic = dupeTags.join(", ") + " are duplicate tags";
                }
            }

            if (fieldUpdate.length === 1 && fieldUpdate[0] === "") {
                fieldUpdate = [];
            }

            dataEvent.target.value = fieldUpdate;

            this.props.changeHandler.apply(this, [dataEvent]);
        }

        this.setState({
            localErrors,
        });

    }

    onStaticBlur(e) {
        this.updateHashtags(e, true);
    }

    addTextTagsToPool(e) {
        let newTags = this.state.inputs.poolField,
            currentTags = (this.props.input.attrs) ? this.props.input.attrs.hashTags.hashPool : [],
            localErrors = this.state.localErrors,
            updatedTags = [],
            dupe = false,
            constants = this.props.app.config.constants;

        if (e) {
            e.preventDefault();
        }

        localErrors.hashPool = '';

        if (newTags === '' || newTags === '#') {
            localErrors.hashPool = 'A tag must contain a character (other than # naturally)';
            this.setState({
                localErrors
            });
            return;
        }

        newTags = newTags.split(" ");

        if ((newTags.length + currentTags.length) > constants.HASH_POOL_MAX) {
            localErrors.hashPool = 'The maximum number of dynamic tags allowed is: ' + constants.HASH_POOL_MAX;
        } else {
            for (let i = 0; i < newTags.length; ++i) {
                if (!newTags[i].match(/^\#/)) {
                    newTags[i] = "#" + newTags[i];
                }
                if (this.dupeCheck(newTags[i], 'pool')) {
                    localErrors.hashPool = newTags[i] + ' is a duplicate tag';
                    dupe = true;
                    continue;
                }
                updatedTags.push(newTags[i]);
            }

            if (!dupe) {
                updatedTags = currentTags.concat(updatedTags);
                this.updateTags(updatedTags);
            }
        }

        this.setState({
            inputs: {
                poolField: ''
            },
            localErrors
        });

    }

    addRelatedTag(e) {
        let tag = e.currentTarget.dataset.tag,
            currentTags = (this.props.input.attrs) ? this.props.input.attrs.hashTags.hashPool : [],
            localErrors = this.state.localErrors,
            constants = this.props.app.config.constants;

        if (localErrors.modal) {
            localErrors.modal = '';
        }

        if (!tag.match(/^#/)) {
            tag = "#" + tag;
        }

        if (currentTags.indexOf(tag) >= 0) {
            currentTags.splice(currentTags.indexOf(tag), 1);
        } else {
            if (this.dupeCheck(tag, 'pool')) {
                localErrors.modal = tag + " is already in use.";
                this.setState({
                    localErrors
                });
                return;
            }

            if ((currentTags.length + 1) > constants.HASH_POOL_MAX) {
                localErrors.modal = 'The maximum number of dynamic tags allowed is: ' + constants.HASH_POOL_MAX;
                this.setState({
                    localErrors
                });
                return;
            }

            currentTags.push(tag);
        }


        this.updateTags(currentTags);

    }

    updateTags(newTags) {
        let dataEvent = {
            target: {
                value: []
            },
            currentTarget: {
                dataset: {
                    field: this.props.statePath + ".attrs.hashTags.hashPool"
                }
            }
        },
        poolActiveEvent = {
            target: {
                value: 1
            },
            currentTarget: {
                dataset: {
                    field: this.props.statePath + ".attrs.hashTags.poolActive"
                }
            }
        };

        dataEvent.target.value = newTags;

        this.props.changeHandler.apply(this, [dataEvent]);

        if (parseInt(this.props.input.attrs.hashTags.poolActive, 10) === 0) {
            this.props.changeHandler.apply(this, [poolActiveEvent]);
        }

    }

    findTags(e) {
        let query = this.state.inputs.poolField,
            localErrors = this.state.localErrors;

        e.preventDefault();

        localErrors.hashPool = '';
        localErrors.search = '';

        if (query === '') {
            localErrors.hashPool = "We need at least a character for a related hashtag search.";
            this.setState({
                localErrors
            });
            return;
        }

        this.props.getRelatedHashtags(query);

        this.setState({
            searchingRelated: true
        });

    }

    removeTag(e) {
        let tag = e.currentTarget.dataset.tag,
            pool = this.props.input.attrs.hashTags.hashPool,
            nextPool = [],
            dataEvent = {
                target: {
                    value: []
                },
                currentTarget: {
                    dataset: {
                        field: this.props.statePath + ".attrs.hashTags.hashPool"
                    }
                }
            };


        for (let i = 0; i < pool.length; ++i) {
            if (pool[i] !== tag) {
                nextPool.push(pool[i]);
            }
        }

        dataEvent.target.value = nextPool;

        this.props.changeHandler.apply(this, [dataEvent]);

    }

    dupeCheck(tag, source) {
        let poolTags = (this.props.input.attrs && _.isArray(this.props.input.attrs.hashTags.hashPool)) ? this.props.input.attrs.hashTags.hashPool : [],
            staticTags = (this.props.input.attrs && _.isArray(this.props.input.attrs.hashTags.hashStatic)) ? this.props.input.attrs.hashTags.hashStatic : [],
            i = 0,
            poolCount = 0,
            staticCount = 0;

        for (i = 0; i < poolTags.length; ++i) {
            if (poolTags[i] === tag) {
                poolCount++;
            }
        }

        for (i = 0; i < staticTags.length; ++i) {
            if (staticTags[i] === tag) {
                staticCount++;
            }
        }

        if ((source === 'pool' && staticCount >= 1) ||
            (source === 'static' && poolCount >= 1) ||
            (source === 'pool' && poolCount >= 1) ||
            (source === 'static' && staticCount >= 2)) {
            return true;
        }

        return false;

    }

    closeTagModal(e) {
        e.preventDefault();

        this.props.clearRelatedHashtags();
        this.setState({
            relatedTags: [],
            inputs: {
                poolField: ''
            }
        });

    }

    render() {
        let constants = this.props.app.config.constants,
            styleOptions = [
                {value: 0, label: "Hashtags Off"},
                {value: STYLE_AUTO_DETECT, label: 'Auto-Detected Hashtags'},
                {value: STYLE_FIXED_DYNAMIC, label: 'Fixed/Dynamic Hashtags'},
                {value: STYLE_AI_GENERATED, label: 'Smart Hashtags'}
            ],
            placmentOptions = [
                {value: constants.HASH_PRE, label: ''},
                {value: constants.HASH_POST, label: ''}
            ],
            countOptions = [0, 1, 2, 3, 4, 5].map(function(value){
                return {value, label: value};
            }),
            autoHashOptions = [
                {value:1, label: 'Start of Post'},
                {value:2, label: 'End of Post'},
                {value:3, label: 'Inline'}
            ],
            autoHashSources = [
                {value: constants.HASH_SRC_PAGE, label: 'Look in linked web page'},
                {value: constants.HASH_SRC_ITEM, label: 'Look in feed items'}
            ],
            smartHashtagsOptions = [
                {value:1, label: '1'},
                {value:2, label: '2'},
                {value:3, label: '3'},
                {value:4, label: '4'},
                {value:5, label: '5'},
            ],
            autoHashToggle = null,
            autoHashDetail = null,
            autoHash = (this.props.input.attrs) ? parseInt(this.props.input.attrs.autoHash, 10) : 0,
            autoHashNum = (this.props.input.attrs) ? parseInt(this.props.input.attrs.autoHashNum, 10) : 0,
            autoHashSpaces = (this.props.input.attrs) ? parseInt(this.props.input.attrs.autoHashSpaces, 10) : 0,
            autoHashSource = (this.props.input.attrs) ? parseInt(this.props.input.attrs.autoHashSource, 10) : 0,
            hashtagPlacement = (this.props.input.attrs) ? this.props.input.attrs.hashTags.hashtagPlacement : constants.HASH_POST,
            // default static active to true for migration -- it won't be set for prior users, but as soon as they touch it (and for new setups) it'll be set
            staticActive = (this.props.input.attrs && this.props.input.attrs.hashTags.staticActive !== undefined) ? parseInt(this.props.input.attrs.hashTags.staticActive, 10) : 1,
            staticTags = (this.props.input.attrs && this.props.input.attrs.hashTags.hashStatic !== undefined) ? this.props.input.attrs.hashTags.hashStatic : [],
            hashtagPool = (this.props.input.attrs && this.props.input.attrs.hashTags.hashPool !== undefined) ? this.props.input.attrs.hashTags.hashPool : [],
            poolCount = (this.props.input.attrs && this.props.input.attrs.hashTags.poolNum !== undefined) ? this.props.input.attrs.hashTags.poolNum : 0,
            poolActive = (this.props.input.attrs && this.props.input.attrs.hashTags.poolActive !== undefined) ? this.props.input.attrs.hashTags.poolActive : 0,
            smartHashtagsActive = (this.props.input.attrs && this.props.input.attrs.hashTags.smartHashtags !== undefined) ? this.props.input.attrs.hashTags.smartHashtags : 0,
            smartHashtagQty = (this.props.input.attrs && this.props.input.attrs.hashTags.smartHashtagQty !== undefined) ? this.props.input.attrs.hashTags.smartHashtagQty : 5,
            poolDisplay = null,
            poolDisplayDefault = null,
            topicAccessHandler = () => {},
            topicAccessClass = '',
            staticAccessHandler = () => {},
            staticAccessClass = '',
            poolAccessHandler = () => {},
            poolAccessClass = '',
            smartHashtagsAccessHandler = () => {},
            smartHashtagsAccessClass = '',
            tagModal = null,
            modalError = null,
            staticError = null,
            poolError = null,
            searchError = null,
            countWarning = null,
            staticWarning = null,
            smartHashtagsError = null,
            warning = null,
            autoHashIndicatorClass = 'status-indicator',
            staticIndicatorClass = 'status-indicator',
            poolIndicatorClass = 'status-indicator',
            smartHashtagsIndicatorClass = 'status-indicator',
            activeUI = null;

        /*
        <fieldset>
            <legend>Hashtag Settings<HelpButton which="hashtagSettings"/></legend>
            <StyledSelect
                options={firstPullOptions}
                linkedField={this.props.statePath + ".hashTags.hashPlacement"}
                value={hashtagPlacement}
                selectClass="large"
                onChange={this.props.changeHandler}/>
        </fieldset>
         */

        if (!this.props.user.perms.resources.autoHash) {
            topicAccessHandler = () => {
                this.props.showUpgradeModal(this.props.closeAllModals, 'autoHashtags', null, 'input_edit');
            };
            topicAccessClass = 'feature-disabled ';
            autoHashIndicatorClass += ' disabled';
        }

        if (!this.props.user.perms.resources.hashStatic) {
            staticAccessHandler = () => {
                this.props.showUpgradeModal(this.props.closeAllModals, 'staticHashtags', null, 'input_edit');
            };
            staticAccessClass = 'feature-disabled ';
            staticIndicatorClass += ' disabled';
            if (staticTags.length > 0) {
                staticWarning = (
                    <p className="count-warning">We'll hold on to your Fixed Hashtags, but they won't post or be editable with your current plan.</p>
                );
            }
        }

        if (!this.props.user.perms.resources.smartHashtags) {
            smartHashtagsAccessHandler = () => {
                this.props.showUpgradeModal(this.props.closeAllModals, 'smartHashtags', null, 'input_edit');
            };
            smartHashtagsAccessClass = 'feature-disabled ';
            smartHashtagsIndicatorClass += ' disabled';
        }

        if (!this.props.user.perms.resources.hashPool) {
            poolAccessHandler = () => {
                this.props.showUpgradeModal(this.props.closeAllModals, 'hashtagPool', null, 'input_edit');
            };
            poolAccessClass = 'feature-disabled pool';
            if (hashtagPool && hashtagPool.length) {
                poolAccessClass += ' has-pool';
            }
            poolIndicatorClass += ' disabled';
        }

        poolActive = (parseInt(poolActive)) ? true : false;

        autoHashToggle = (
            <div>
                <ErrorModule
                    app={this.props.app}
                    keys={['INPUT_CREATE', 'INPUT_UPDATE']}
                    render={(state) => {
                        return (
                            <FieldError field="attrs.autoHash" errors={state.errors}/>
                        );
                    }}/>
                <StyledSelect
                    options={autoHashOptions}
                    linkedField={this.props.statePath + ".attrs.autoHash"}
                    value={autoHash}
                    selectClass="med"
                    onChange={this.props.changeHandler}/>
            </div>
        );

        if (autoHash) {
            let autoCountOptions = _.clone(countOptions);
            autoCountOptions.shift();
            autoHashDetail = (
                <div>
                    <ErrorModule
                        app={this.props.app}
                        keys={['INPUT_CREATE', 'INPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="attrs.autoHashNum" errors={state.errors}/>
                            );
                        }}/>
                    <div className="sub-label">Max # of Auto Detected Hashtags to post:</div>
                    <StyledSelect
                        options={autoCountOptions}
                        linkedField={this.props.statePath + ".attrs.autoHashNum"}
                        onChange={this.props.changeHandler}
                        value={autoHashNum}
                        selectClass="med" />
                    <div className="sub-label">Blank Space Handling</div>
                    <ErrorModule
                        app={this.props.app}
                        keys={['INPUT_CREATE', 'INPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="attrs.autoHashSpaces" errors={state.errors}/>
                            );
                        }}/>
                    <StyledSelect
                        options={[{value:0, label: 'Remove Spaces'}, {value:1, label: 'Changes spaces to underbars'}]}
                        linkedField={this.props.statePath + ".attrs.autoHashSpaces"}
                        onChange={this.props.changeHandler}
                        value={autoHashSpaces}
                        selectClass="med" />
                    <div className="sub-label">Where should we look for hashtags?</div>
                    <ErrorModule
                        app={this.props.app}
                        keys={['INPUT_CREATE', 'INPUT_UPDATE']}
                        render={(state) => {
                            return (
                                <FieldError field="attrs.autoHashSource" errors={state.errors}/>
                            );
                        }}/>
                    <StyledSelect
                        options={autoHashSources}
                        linkedField={this.props.statePath + ".attrs.autoHashSource"}
                        onChange={this.props.changeHandler}
                        value={autoHashSource}
                        selectClass="med" />
                </div>
            );
        }

        if (staticTags && staticTags.length) {
            staticTags = staticTags.join(" ");
        }  else {
            staticTags = '';
        }

        if (hashtagPool && hashtagPool.length) {
            poolDisplay = (
                <div className="hashtag-pool-wrapper">
                    <ul className="hashtag-list clearfix">
                        {hashtagPool.map((hashtag, i) =>{
                            return (
                                <li key={"hashtag-" + i} className="hashtag">
                                    {hashtag} <i className="icon ion-close-circled" onClick={this.removeTag} data-tag={hashtag} role="button" aria-label="remove hashtag"></i>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            );
            if (parseInt(poolCount, 10) === 0) {
                countWarning = (
                    <p className="count-warning">Activate Dynamic Hashtags Pool by setting a count greater than zero!</p>
                );
            }
            if (!this.props.user.perms.resources.hashPool) {
                countWarning = (
                    <p className="count-warning">We'll hold on to your Dynamic Hashtag Pool, but they won't post or be editable with your current plan.</p>
                );
            }
        } else if (!this.props.user.perms.resources.hashPool) {
            poolDisplayDefault = (
                <div className="hashtag-pool-wrapper">
                    <ul className="hashtag-list clearfix">
                        {["#sampletags", "#thesecouldbeyours", "#sousvide", "#baking", "#cheflife", "#latteart", "#coffee", "#cookies"].map((hashtag, i) =>{
                            return (
                                <li key={"hashtag-" + i} className="hashtag">
                                    {hashtag} <i className="icon ion-close-circled" onClick={this.removeTag} data-tag={hashtag} role="button" aria-label="remove hashtag"></i>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            );
        }

        if (this.state.searchingRelated) {
            tagModal = (
                <div className='hashtag-modal'>
                    <Loading />
                </div>
            );
        } else if (this.props.utilities.relatedTags.length) {
            if (this.state.localErrors.modal) {
                modalError = (
                    <div className="fieldset-error">
                        {this.state.localErrors.modal}
                    </div>
                );
            }
            tagModal = (
                <div className="hashtag-modal">
                    {modalError}
                    <ul className="hashtag-modal-list clearfix">
                        {this.props.utilities.relatedTags.map((tag, i) => {
                            let active = '',
                                searchTag = tag;

                            if (!searchTag.match(/\^/)) {
                                searchTag = "#" + searchTag;
                            }

                            if (hashtagPool.indexOf(searchTag) >= 0) {
                                active = 'active';
                            }

                            return (
                                <li key={"tag-" + i + '-' + active} className={"hashtag-modal-item " + active} data-tag={tag} onClick={this.addRelatedTag} role="button" aria-label="add tag">
                                    #{tag}
                                </li>
                            );
                        })}
                    </ul>
                    <div className="hashtag-modal-controls">
                        <a href="#" className="form-cancel" onClick={this.closeTagModal}>cancel</a>
                        <button className="btn-primary fixed active" onClick={this.closeTagModal}>
                            add
                        </button>
                    </div>
                </div>
            );
        }

        if (this.state.localErrors.hashStatic) {
            staticError = (
                <div className="fieldset-error">
                    {this.state.localErrors.hashStatic}
                </div>
            );
        }

        if (this.state.localErrors.hashPool) {
            poolError = (
                <div className="fieldset-error">
                    {this.state.localErrors.hashPool}
                </div>
            );
        }

        if (this.state.localErrors.search) {
            searchError = (
                <div className="fieldset-error">
                    {this.state.localErrors.search}
                </div>
            );
        }

        if (this.state.localErrors.smartHashtags) {
            smartHashtagsError = (
                <div className="fieldset-error">
                    {this.state.localErrors.smartHashtags}
                </div>
            );
        }

        if (this.state.hashtagStyle === STYLE_AUTO_DETECT) {
            activeUI = (
                <fieldset>
                    <legend>Auto Detected Hashtags<HelpButton {...this.props} which="autoHashtag"/></legend>
                    <div className="feature-wrapper">
                        <div className={topicAccessClass} onClick={topicAccessHandler}></div>
                        {autoHashToggle}
                        {autoHashDetail}
                    </div>
                </fieldset>
            );
        } else if (this.state.hashtagStyle === STYLE_FIXED_DYNAMIC) {
            activeUI = (
                <div>
                    <fieldset>
                        <legend>Fixed Hashtags<HelpButton which="hashtagStatic"/></legend>
                        <div className="feature-wrapper">
                            <div className={staticAccessClass} onClick={staticAccessHandler}></div>
                            <ErrorModule
                                app={this.props.app}
                                keys={['INPUT_CREATE', 'INPUT_UPDATE']}
                                render={(state) => {
                                    return (
                                        <FieldError field="attrs.hashTags.hashStatic" errors={state.errors}/>
                                    );
                                }}/>
                            <div className="feature-copy">
                                {staticError}
                                {staticWarning}
                            </div>
                            <div className="toggle-wrapper">
                                <ToggleControl
                                    activeLabel="On"
                                    inactiveLabel="Off"
                                    labelPlacement="right"
                                    labelClass="advanced-toggle-label"
                                    linkedField={this.props.statePath + ".attrs.hashTags.staticActive"}
                                    active={staticActive ? true : false}
                                    callback={this.props.changeHandler}/>
                            </div>
                            <UncontrolledTextInput
                                className="text-input medium"
                                value={staticTags}
                                placeholder="e.g. #news"
                                data-field={this.props.statePath + ".attrs.hashTags.hashStatic"}
                                onChange={this.updateHashtags}
                                onBlur={this.onStaticBlur} />
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend>
                            Dynamic Hashtag Pool
                            <HelpButton which="hashtagPool"/>
                        </legend>
                        <div className="feature-wrapper">
                            <div className={poolAccessClass} onClick={poolAccessHandler}></div>
                            <ErrorModule
                                app={this.props.app}
                                keys={['INPUT_CREATE', 'INPUT_UPDATE']}
                                render={(state) => {
                                    return (
                                        <FieldError field="attrs.hashTags.poolActive" errors={state.errors}/>
                                    );
                                }}/>
                            <ErrorModule
                                app={this.props.app}
                                keys={['INPUT_CREATE', 'INPUT_UPDATE']}
                                render={(state) => {
                                    return (
                                        <FieldError field="attrs.hashTags.hashPool" errors={state.errors}/>
                                    );
                                }}/>
                            {searchError}
                            {poolError}
                            <div className="feature-copy">
                                {countWarning}
                                Include a maximum of
                                    <StyledSelect
                                        options={countOptions}
                                        linkedField={this.props.statePath + ".attrs.hashTags.poolNum"}
                                        value={poolCount}
                                        selectClass="mini inline"
                                        onChange={this.props.changeHandler}/> from your pool in every post
                            </div>
                            <div className="inline-controls">
                                <UncontrolledTextInput
                                    className="text-input hashtag-pool"
                                    value={this.state.inputs.poolField}
                                    placeholder="e.g. #contentmarketing"
                                    data-field="inputs.poolField"
                                    onChange={this.updateField} />
                                <button className="btn-secondary add-hashtag" onClick={this.addTextTagsToPool}>Add</button>
                                <button className="btn-secondary find-related" onClick={this.findTags}>Find Related</button>
                            </div>
                            {poolDisplayDefault}
                            {tagModal}
                        </div>
                        <div>
                            {poolDisplay}
                        </div>
                    </fieldset>
                </div>
            );
        } else if (this.state.hashtagStyle === STYLE_AI_GENERATED) {
            activeUI = (
                <div>
                    <fieldset>
                        <legend>Smart Hashtags<HelpButton which="smartHashtags"/></legend>
                        <div className="feature-wrapper">
                            <div className={smartHashtagsAccessClass} onClick={smartHashtagsAccessHandler}></div>
                            <ErrorModule
                                app={this.props.app}
                                keys={['INPUT_CREATE', 'INPUT_UPDATE']}
                                render={(state) => {
                                    return (
                                        <FieldError field="attrs.hashTags.smartHashtags" errors={state.errors}/>
                                    );
                                }}/>
                            <div className="feature-copy">
                                {smartHashtagsError}
                            </div>
                            <div className="toggle-wrapper">
                                <ToggleControl
                                    activeLabel="On"
                                    inactiveLabel="Off"
                                    labelPlacement="right"
                                    labelClass="advanced-toggle-label"
                                    linkedField={this.props.statePath + ".attrs.hashTags.smartHashtags"}
                                    active={smartHashtagsActive ? true : false}
                                    callback={this.props.changeHandler}/>
                            </div>
                            <div className="feature-copy">
                                Include a maximum of
                                    <StyledSelect
                                        options={smartHashtagsOptions}
                                        linkedField={this.props.statePath + ".attrs.hashTags.smartHashtagQty"}
                                        value={smartHashtagQty}
                                        selectClass="mini inline"
                                        onChange={this.props.changeHandler}/> AI generated hashtags in every post from this feed.
                            </div>
                            <div className="disclaimer">
                                *Auto AI-generated results may not always be accurate or perfectly tailored.
                            </div>
                        </div>
                    </fieldset>
                </div>
            );
        }


        return (
            <div className="editor-panel hashtags">
                <fieldset>
                    <legend className="hashtag-legend">Set Hashtag Style<a href="https://support.dlvrit.com/hc/en-us/articles/360009187014-What-happened-to-my-Hashtags-" target="_blank" className="hashtag-missing">Hashtags not posting?</a></legend>
                    <StyledSelect
                        options={styleOptions}
                        value={this.state.hashtagStyle}
                        selectClass="med inline"
                        onChange={this.changeStyle}/>
                </fieldset>
                {activeUI}
            </div>
        );
    }
}

InputHashtagPanel.displayName = "InputHashtagPanel";

InputHashtagPanel.propTypes = {
    statePath: PropTypes.string
};

InputHashtagPanel.defaultProps = {
    statePath: 'input'
};

export default ComponentWithContext(InputHashtagPanel);
